import tocCoin from '../assets/ToC-Coin.png';
import styles from './BalanceInfo.module.css';

interface BalanceInfoProps {
  value?: string;
  size?: number;
}

export function BalanceInfo({ value = '0', size = 48 }: BalanceInfoProps) {
  return (
    <div className={styles.container}>
      <span className={styles.value} style={{ fontSize: size }}>
        {value}
      </span>
      <img
        src={tocCoin}
        alt="ToC Coin"
        className={styles.coin}
        style={{ width: size, height: size }}
      />
    </div>
  );
}

export default BalanceInfo;
